import { render, staticRenderFns } from "./globalCourse.vue?vue&type=template&id=66b20346&scoped=true&"
import script from "./globalCourse.vue?vue&type=script&lang=js&"
export * from "./globalCourse.vue?vue&type=script&lang=js&"
import style0 from "./globalCourse.vue?vue&type=style&index=0&id=66b20346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b20346",
  null
  
)

export default component.exports